module.exports = __webpack_public_path__ + "static/img/IMG_20160918_173702.2c854b5a.jpg";